export default __webpack_public_path__ + "static/media/slide3.a34d4bf3.jpg";